
import { Component, inject } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { FeatureAPIService } from '@modules'
import { Store } from '@ngrx/store'
import { BvCommentsModule } from '@ziptility/components/comments/comments.module'
import { AssetProfileService } from '@ziptility/feature/asset-profile.service'

@Component({
    selector: 'feature-comments',
    template: `
    <bv-comments
      [comments]="featureProfileService.comments()"
      (onCreate)="onCreateComment($event)"
      (onDelete)="onDeleteComment($event)"
    ></bv-comments>
  `,
    imports: [BvCommentsModule]
})
export class FeatureCommentsComponent {
  readonly route = inject(ActivatedRoute)
  readonly featureService = inject(FeatureAPIService)
  readonly featureProfileService = inject(AssetProfileService)
  readonly store = inject(Store)

  onCreateComment({ message, mentions }) {
    const { featureId } = this.route.snapshot.params
    this.featureProfileService.createComment(
      featureId,
      message,
      mentions.map((m) => m.id),
    )
  }

  onDeleteComment({ id }) {
    const { featureId } = this.route.snapshot.params
    this.featureProfileService.deleteComment(featureId, id)
  }
}
